// @flow
import React, { useState, useMemo, useEffect, useContext, useRef } from "react";
import ReactDOM from "react-dom";

export let ModalRoot = React.createContext();

export function ModalRootProvider(props) {
  let [queue, setQueue] = useState([]);

  let context = useMemo(() => {
    return {
      enqueue: modal => setQueue(q => [...q, modal]),
      dequeue: modal => setQueue(q => q.filter(r => r !== modal))
    };
  }, [queue]);

  let modal = null;

  if (queue.length > 0) {
    let ref = queue[queue.length - 1];
    modal = <div key={queue.length - 1} ref={ref} />;
  }

  return (
    <ModalRoot.Provider value={context}>
      {modal}
      {props.children}
    </ModalRoot.Provider>
  );
}

export function Modal(props) {
  const { mode } = props;
  let [isMounted, setIsMounted] = useState(false);

  let container = useRef(null);
  let modalRoot = useContext(ModalRoot);

  let callback = useMemo(() => {
    return node => {
      container.current = node;

      setIsMounted(node != null);
    };
  }, []);

  useEffect(() => {
    if (mode) {
      modalRoot.enqueue(callback);
    } else {
      setIsMounted(false);
      modalRoot.dequeue(callback);
    }

    let prevMode = mode;

    return () => {
      if (prevMode === true) {
        setIsMounted(false);
        modalRoot.dequeue(callback);
      }
    };
  }, [mode]);

  return mode && isMounted
    ? ReactDOM.createPortal(props.children, container.current)
    : null;
}



// WEBPACK FOOTER //
// ./src/components/common/Modal.js